import * as Types from '../../common/types/graphql-types';

import { gql } from '@apollo/client';
import { BaseUserFragmentDoc } from '../../user/fragments/baseUser';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PurchaseProductMutationVariables = Types.Exact<{
  price: Types.Scalars['String'];
  revision?: Types.InputMaybe<Types.Scalars['UUID']>;
  paymentMethod: Types.Scalars['String'];
  coupon?: Types.InputMaybe<Types.Scalars['String']>;
  referralCode?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type PurchaseProductMutation = { __typename?: 'Mutation', purchaseProduct: { __typename?: 'PurchaseProductOutput', user?: { __typename?: 'User', id: string, avatar?: string | null | undefined, firstName: string, lastName: string, username: string } | null | undefined, invoice: { __typename?: 'Invoice', id: string, items: Array<{ __typename?: 'InvoiceLineItem', id: string, description: string, amount: number, discounts?: Array<{ __typename?: 'Discount', name: string, amount: number }> | null | undefined }> }, revision?: { __typename?: 'Revision', id: string, track: { __typename?: 'Track', id: string }, master?: { __typename?: 'AudioData', mp3?: string | null | undefined, wav?: string | null | undefined } | null | undefined } | null | undefined } };


export const PurchaseProductDocument = gql`
    mutation PurchaseProduct($price: String!, $revision: UUID, $paymentMethod: String!, $coupon: String, $referralCode: String) {
  purchaseProduct(
    input: {price: $price, revision: $revision, paymentMethod: $paymentMethod, coupon: $coupon, referralCode: $referralCode}
  ) {
    user {
      ...BaseUser
    }
    invoice {
      id
      items {
        id
        description
        amount
        discounts {
          name
          amount
        }
      }
    }
    revision {
      id
      track {
        id
      }
      master {
        mp3
        wav
      }
    }
  }
}
    ${BaseUserFragmentDoc}`;
export type PurchaseProductMutationFn = Apollo.MutationFunction<PurchaseProductMutation, PurchaseProductMutationVariables>;

/**
 * __usePurchaseProductMutation__
 *
 * To run a mutation, you first call `usePurchaseProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseProductMutation, { data, loading, error }] = usePurchaseProductMutation({
 *   variables: {
 *      price: // value for 'price'
 *      revision: // value for 'revision'
 *      paymentMethod: // value for 'paymentMethod'
 *      coupon: // value for 'coupon'
 *      referralCode: // value for 'referralCode'
 *   },
 * });
 */
export function usePurchaseProductMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseProductMutation, PurchaseProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseProductMutation, PurchaseProductMutationVariables>(PurchaseProductDocument, options);
      }
export type PurchaseProductMutationHookResult = ReturnType<typeof usePurchaseProductMutation>;
export type PurchaseProductMutationResult = Apollo.MutationResult<PurchaseProductMutation>;
export type PurchaseProductMutationOptions = Apollo.BaseMutationOptions<PurchaseProductMutation, PurchaseProductMutationVariables>;